<template>
  <div class="content">
    <h3>Mon Gaston Statistiques</h3>
    <card>
      <div class="row">
        <base-input class="col-md-4 col-sm-6 col-xs-12">
          <el-select
            class="select-primary"
            v-model="selectedProduct"
            :disabled="loading"
            placeholder="TYPE DE PRODUIT"
            style="width: 100%;"
          >
            <el-option
              v-for="option in productOptions"
              :key="option.value"
              class="select-primary"
              :label="option.label.toUpperCase()"
              :value="option.value"
            />
          </el-select>
        </base-input>
        <base-input class="col-md-4 col-sm-6 col-xs-12">
          <el-date-picker
            v-model="StartDate"
            :disabled="loading"
            value-format="yyyy-MM-dd"
            type="date"
            :placeholder="$t('table.columns.Startdate').toUpperCase()"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </base-input>
        <base-input class="col-md-4 col-sm-6 col-xs-12">
          <el-date-picker
            v-model="EndDate"
            :disabled="loading"
            value-format="yyyy-MM-dd"
            type="date"
            :placeholder="$t('table.columns.Enddate').toUpperCase()"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </base-input>
      </div>
      <div class="row">
        <div class="col-12 text-right">
          <base-button
            v-if="loading"
            loading
            class="btn btn-default"
          >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
          <button
            v-else
            class="btn btn-default"
            @click="search"
          >{{ $t("buttons.BtnSearch").toUpperCase() }}</button>
        </div>
      </div>
    </card>
    <!-- <card px-4 pt-4 pb-2 v-if="spend_grouped && spend_grouped.length > 0 || loading">
      <div class="row mb-0">
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="card summary-card">
            <div class="card-body text-center">
              <h6 class="card-subtitle mb-2 text-muted">Spend Total</h6>
              <h4 class="card-title mb-0" v-if="!loading">{{ formatThounsends(totalSpend, true, 2) }} €</h4>
              <div v-else class="d-flex justify-content-center">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="card summary-card">
            <div class="card-body text-center">
              <h6 class="card-subtitle mb-2 text-muted">Marge Totale</h6>
              <h4 class="card-title mb-0" v-if="!loading">{{ formatThounsends(totalMarge, true, 2) }} €</h4>
              <div v-else class="d-flex justify-content-center">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <div class="card summary-card">
            <div class="card-body text-center">
              <h6 class="card-subtitle mb-2 text-muted">% Marge</h6>
              <h4 class="card-title mb-0" v-if="!loading" :class="color_marge_summary()">{{ formatThounsends(pourcentageMarge, true, 2) }} %</h4>
              <div v-else class="d-flex justify-content-center">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex justify-content-end mt-2 mb-2">
        <base-button
          @click="summaryTableExpanded = !summaryTableExpanded"
          class="btn-link"
          type="market"
          size="sm"
          icon
          :title="summaryTableExpanded ? 'Masquer le détail' : 'Afficher le détail (spend groupé)'"
        >
          <i :class="summaryTableExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </base-button>
      </div>
      <div v-if="!loading && summaryTableExpanded" class="mb-3" style="border-top: 1px solid rgba(255, 255, 255, 0.1); padding-top: 1rem;">
        <el-table
          :data="spend_grouped"
          style="background: transparent; width: 100%;"
          :show-header="true"
          show-summary
          :summary-method="getSpendGroupedSummaries"
          empty-text="Aucune donnée"
          class="customtable_cmd"
        >
          <el-table-column label="Tags principaux" min-width="280" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <template v-for="tag in (scope.row.tags_principaux || [])">
                  <label class="main-tag-name">{{ tag.nom_tag_principal || '' }}</label><br>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="spend" label="Dépenses" min-width="120" align="center" sortable>
            <template slot-scope="scope">
              <span style="display: block; text-align: center;">{{ formatThounsends(scope.row.spend, true, 2) }} €</span>
            </template>
          </el-table-column>
          <el-table-column prop="ca_an" label="CA" min-width="100" align="center" sortable>
            <template slot-scope="scope">
              <span style="display: block; text-align: center;">{{ formatThounsends(scope.row.ca_an, true, 0) }} €</span>
            </template>
          </el-table-column>
          <el-table-column prop="marge" label="Marge" min-width="120" align="center" sortable>
            <template slot-scope="scope">
              <span style="display: block; text-align: center;">{{ formatThounsends(scope.row.marge, true, 2) }} €</span>
            </template>
          </el-table-column>
          <el-table-column prop="pourcentage_marge" label="% Marge" min-width="100" align="center" sortable>
            <template slot-scope="scope">
              <span style="display: block; text-align: center;" :class="scope.row.pourcentage_marge  >= 0 ? 'text-success' : 'text-danger'">{{ formatThounsends(scope.row.pourcentage_marge, true, 2) }} %</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </card> -->
    <card px-4>
      <div class="row">
        <div class="col-xl-3 col-sm-6">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-xl-4 col-sm-6 text-right" style="margin-left: auto;">
          <base-input>
            <el-input
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              :placeholder="$t('buttons.BtnSearch2').toUpperCase()"
              v-model="searchQuery"
              aria-controls="datatables"
            >
            </el-input>
          </base-input>
        </div>
      </div>
      <el-table
        :data="paginatedStatsData"
        v-loading="loading"
        :disabled="loading"
        row-class-name="booking-table-rows"
        class="customtable_cmd"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column type="expand">
          <template scope="scope">
            <div v-if="scope.row.details && scope.row.details.length > 0">
              <div class="table w-100 expanded-content">
                <el-table
                  :data="getSortedDetails(scope.row.details)"
                  class=" details-table"
                  :fit="true"
                  style="width: 100%; border: 1px solid rgba(255, 255, 255, 0.1);"
                >
                  <el-table-column
                    prop="nom_sous_tag"
                    label="Nom sous-tag"
                    min-width="460"
                    show-overflow-tooltip
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-tag-name">{{ detailScope.row.nom_sous_tag.toUpperCase() }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="position"
                    label="Position"
                    min-width="120"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ detailScope.row.position || '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="nbr_impressions"
                    label="Impressions"
                    min-width="150"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.nbr_impressions || 0) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="nbr_cliques"
                    label="Cliques"
                    min-width="150"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.nbr_cliques) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="nbr_leads"
                    label="Leads"
                    min-width="120"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.nbr_leads) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="vente"
                    label="Vente"
                    min-width="100"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.vente || 0) + ' €' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="ca"
                    label="CA"
                    min-width="100"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <strong class="detail-number">{{ formatThounsends(detailScope.row.ca || 0, true, 1) + ' €' }}</strong>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="ctr"
                    label="CTR"
                    min-width="100"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.ctr || 0, true, 2) + ' %' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="ecpc"
                    label="ECPC"
                    min-width="100"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.ecpc || 0, true, 2) + ' €' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="mer"
                    label="MER"
                    min-width="90"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <span class="detail-number">{{ formatThounsends(detailScope.row.mer || 0) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="mer_percent"
                    label="% MER"
                    min-width="100"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <label v-if="detailScope.row.lm_client === 'WM'"
                        :style="((detailScope.row.mer / detailScope.row.nbr_leads) * 100 < 30 || detailScope.row.nbr_leads == 0) ? 'color: red' : 'color: green'"
                        class="detail-number"
                      >
                        {{ (detailScope.row.nbr_leads != 0) ? (((detailScope.row.mer / detailScope.row.nbr_leads) * 100).toFixed(2)) : (0).toFixed(2) }} %
                      </label>
                      <template v-else>NC</template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="ca_mg"
                    label="CA MG"
                    min-width="110"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <template v-if="detailScope.row.lm_client === 'WM'">
                        <span class="detail-number">{{ formatThounsends(detailScope.row.ca_mg || 0, true, 2) + ' €' }}</span>
                      </template>
                      <template v-else>NC</template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="ca_wm"
                    label="CA WM"
                    min-width="110"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <template v-if="detailScope.row.lm_client === 'WM'">
                        <span class="detail-number">{{ formatThounsends(detailScope.row.ca_wm || 0, true, 2) + ' €' }}</span>
                      </template>
                      <template v-else>NC</template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="marge"
                    label="Marge"
                    min-width="110"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <template v-if="detailScope.row.lm_client === 'WM'">
                        <span class="detail-number">{{ formatThounsends(((detailScope.row.ca_mg || 0) + (detailScope.row.ca_wm || 0)) - (detailScope.row.cae || 0), true, 2) + ' €' }}</span>
                      </template>
                      <template v-else>NC</template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="marge_percent"
                    label="% Marge"
                    min-width="115"
                    align="center"
                    sortable
                  >
                    <template scope="detailScope">
                      <label v-if="detailScope.row.lm_client === 'WM'"
                        class="detail-number"
                        :style="color_marge(detailScope.row)"
                      >
                        {{ detailScope.row.cae != 0 ? formatThounsends((((detailScope.row.ca_mg || 0) + (detailScope.row.ca_wm || 0)) - (detailScope.row.cae || 0)) * 100 / detailScope.row.cae, true, 2) : (0).toFixed(2) }} %
                      </label>
                      <template v-else>NC</template>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <p v-else class="text-muted text-center" style="width: 100%;">Aucun détail disponible</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="nom_tag_principal"
          label="Tag principal"
          min-width="300"
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <span class="main-tag-name">{{ scope.row.nom_tag_principal.toUpperCase() }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="nbr_cliques"
          label="Nbr cliques"
          min-width="130"
          show-overflow-tooltip
          sortable
          align="center"
        >
          <template scope="scope">
            <div class="d-flex justify-content-center">
              <span class="text-end">
                {{ formatThounsends(scope.row.nbr_cliques) }}
              </span>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="nbr_leads"
          label="Nbr leads"
          min-width="130"
          show-overflow-tooltip
          sortable
          align="center"
        >
          <template scope="scope">
            <div class="d-flex justify-content-center">
              <span class="text-end">
                {{ formatThounsends(scope.row.nbr_leads) }}
              </span>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="nbr_cliques_sum"
          label="Nbr cliques (sous tags)"
          min-width="200"
          show-overflow-tooltip
          sortable
          align="center"
        >
          <template scope="scope">
            <div class="d-flex justify-content-center">
              <span class="text-end">
                {{ formatThounsends(scope.row.nbr_cliques_sum) }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="nbr_leads_sum"
          label="Nbr leads (sous tags)"
          min-width="200"
          show-overflow-tooltip
          sortable
          align="center"
        >
          <template scope="scope">
            <div class="d-flex justify-content-center">
              <span class="text-end">
                {{ formatThounsends(scope.row.nbr_leads_sum) }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="ca_total"
          label="CA total"
          min-width="150"
          show-overflow-tooltip
          sortable
          :sort-method="sortByTotalCA"
          align="center"
        >
          <template scope="scope">
            <div class="d-flex justify-content-center">
              <strong class="text-end">
                {{ formatThounsends(getTotalCA(scope.row), true, 1) + ' €' }}
              </strong>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t('labels.Datatable.Showing') }} {{ from + 1 }}  {{ $t('labels.Datatable.to') }} {{ to }} {{ $t('labels.Datatable.of') }} {{ total }} {{ $t('labels.Datatable.entries') }}
          </p>
        </div>
        <base-pagination
          type="market"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import { DatePicker, Table, TableColumn, Select, Option } from 'element-ui'
import { BaseAlert, BasePagination } from "src/components";
import moment from 'moment'
import axios from 'axios'
import gql from "graphql-tag";
moment.locale('fr')

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseAlert,
    BasePagination
  },
  data() {
    // Initialiser avec le mois en cours si aucune date n'est sélectionnée
    const startOfMonth = moment().startOf('month').format('YYYY-MM-DD')
    const endOfMonth = moment().endOf('month').format('YYYY-MM-DD')

    return {
      loading: false,
      date_debut: moment().startOf('month').format('YYYY-MM-DD'),
      date_fin: moment().format('YYYY-MM-DD'),
      StartDate: moment().startOf('month').format('YYYY-MM-DD'),
      EndDate: moment().format('YYYY-MM-DD'),
      selectedProduct: 'all',
      statsData: [],
      statsData_tmp: [],
      spend_grouped: [],
      summaryTableExpanded: false,
      periode: null,
      searchQuery: '',
      SkipQuery_caByTag: false,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      productOptions: [
        { value: 'all', label: 'Tous' },
        { value: 'sante', label: 'Santé' },
        { value: 'mon gaston auto', label: 'Auto' },
        { value: 'mon gaston credit conso', label: 'Crédit conso' },
        { value: 'mon gaston credit mini', label: 'Crédit mini (MB)' },
        { value: 'mon gaston eaasy credit', label: 'Easy crédit (MB)' },
        { value: 'mon gaston credit rapide', label: 'Crédit rapide (MB)' },
        { value: 'mon gaston animaux', label: 'Animaux' },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    }
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    filteredStatsData() {
      if (!this.searchQuery || this.searchQuery.trim() === '') {
        return this.statsData;
      }
      const query = this.searchQuery.toLowerCase().trim();
      return this.statsData.filter(item => {
        return item.nom_tag_principal &&
               item.nom_tag_principal.toLowerCase().includes(query);
      });
    },
    total() {
      return this.filteredStatsData.length;
    },
    paginatedStatsData() {
      return this.filteredStatsData.slice(this.from, this.to);
    },
    allSubTags() {
      const tags = []
      this.statsData_tmp.forEach(tagPrincipal => {
        if (tagPrincipal.details && tagPrincipal.details.length > 0) {
          tagPrincipal.details.forEach(detail => {
            if (detail.nom_sous_tag && !tags.includes(detail.nom_sous_tag)) {
              tags.push(detail.nom_sous_tag)
            }
          })
        }
      })
      return tags
    },
    date_start() {
      if (this.statsData_tmp.length === 0) return null
      let minDate = null
      this.statsData_tmp.forEach(tagPrincipal => {
        if (tagPrincipal.details && tagPrincipal.details.length > 0) {
          tagPrincipal.details.forEach(detail => {
            if (detail.date) {
              const dateParts = detail.date.split('/')
              if (dateParts.length === 3) {
                const date = moment(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`, 'YYYY-MM-DD')
                if (!minDate || date.isBefore(minDate)) {
                  minDate = date
                }
              }
            }
          })
        }
      })
      return minDate ? minDate.format('YYYY-MM-DD') : null
    },
    date_end() {
      if (this.statsData_tmp.length === 0) return null
      let maxDate = null
      this.statsData_tmp.forEach(tagPrincipal => {
        if (tagPrincipal.details && tagPrincipal.details.length > 0) {
          tagPrincipal.details.forEach(detail => {
            if (detail.date) {
              const dateParts = detail.date.split('/')
              if (dateParts.length === 3) {
                const date = moment(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`, 'YYYY-MM-DD')
                if (!maxDate || date.isAfter(maxDate)) {
                  maxDate = date
                }
              }
            }
          })
        }
      })
      return maxDate ? maxDate.format('YYYY-MM-DD') : null
    },
    totalSpend() {
      if (!this.spend_grouped || this.spend_grouped.length === 0) return 0
      return this.spend_grouped.reduce((total, item) => {
        return total + (parseFloat(item.spend) || 0)
      }, 0)
    },
    totalMarge() {
      if (!this.spend_grouped || this.spend_grouped.length === 0) return 0
      return this.spend_grouped.reduce((total, item) => {
        return total + (parseFloat(item.marge) || 0)
      }, 0)
    },
    totalCA() {
       if (!this.spend_grouped || this.spend_grouped.length === 0) return 0
      return this.spend_grouped.reduce((total, item) => {
        return total + (parseFloat(item.ca_an) || 0)
      }, 0)
    },
    pourcentageMarge() {
      if (this.totalCA === 0) return 0
      return (this.totalMarge / this.totalCA) * 100
    }
  },
  apollo: {
    caByTag: {
      client: "MARKET",
      query: gql` query ($tags: [String]!,$date_debut: String!,$date_fin: String!,$groupByDate: Boolean) {
        caByTag(tags: $tags, date_debut: $date_debut, date_fin: $date_fin, groupByDate: $groupByDate) {
          ca
          tag
          date
        }
      }`,
      skip() {
        return this.SkipQuery_caByTag;
      },
      variables() {
        return {
          date_debut: this.date_debut,
          date_fin: this.date_fin,
          tags: this.allSubTags,
          groupByDate: true
        }
      },
      fetchPolicy: 'network-only',
      result({ data, loader, networkStatus }) {
        if (data && data.caByTag) {
        // 1) Construire une map { TAG → somme_des_ca_sur_la_période }
        const caWmByTag = data.caByTag.reduce((acc, item) => {
          const tagName = (item.tag || '').toUpperCase()
          const ca = parseFloat(item.ca) || 0
          acc[tagName] = (acc[tagName] || 0) + ca
          return acc
        }, {})

        // 2) Parcourir tes stats et affecter le CA WM par sous-tag (sans tenir compte de la date)
        this.statsData_tmp.forEach(tagPrincipal => {
          if (tagPrincipal.details && tagPrincipal.details.length > 0) {
            tagPrincipal.details.forEach(detail => {
              const nomSousTag = (detail.nom_sous_tag || '').toUpperCase()
              // CA WM total pour ce sous-tag sur la période
              detail.ca_wm = caWmByTag[nomSousTag] || 0
            })
          }
        })

        // 3) Appliquer le filtre produit sur les données mises à jour
        this.applyProductFilter()
        this.SkipQuery_caByTag = true
      }
      }
    }
  },
  methods: {
    async search() {
      // Si aucune date n'est sélectionnée, utiliser le mois en cours
      if (!this.StartDate && !this.EndDate) {
        this.date_debut = moment().startOf('month').format('YYYY-MM-DD')
        this.date_fin = moment().format('YYYY-MM-DD')
      }
      else {
        this.date_debut = this.StartDate
        this.date_fin = this.EndDate
      }

      // Vérifier si la date de début est supérieure à la date de fin
      if (this.date_debut && this.date_fin && moment(this.date_debut).isAfter(moment(this.date_fin))) {
        this.$notify({
          type: 'warning',
          message: 'La date de début ne peut pas être supérieure à la date de fin'
        })
        return
      }

      await this.fetchStats()
    },
    async fetchStats() {
      this.loading = true
      this.statsData = []
      try {
        const accessToken = localStorage.getItem("token_jwt")
        const apiUrl = "https://api-auth-plf.wee-do-it.net/api/v1/get_stats_mongaston_2"

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json"
          },
          params: {
            date_start: this.date_debut,
            date_end: this.date_fin
          }
        })

        if (response.data.success) {
          this.statsData_tmp = response.data.data || []
          // Appliquer le filtre produit après la récupération des données
          this.applyProductFilter()
          this.spend_grouped = response.data.spend_grouped || []
          this.summaryTableExpanded = false
          this.periode = response.data.periode
          this.SkipQuery_caByTag = false
        } else {
          this.$notify({
            type: 'warning',
            message: 'Erreur lors de la récupération des données'
          })
        }
      } catch (error) {
        console.error("Error fetching stats:", error)
        this.$notify({
          type: 'danger',
          message: 'Échec de la récupération des données. Veuillez réessayer.'
        })
      } finally {
        this.loading = false
      }
    },
    applyProductFilter() {
      // Si "Tous" est sélectionné, on affiche toutes les données
      if (this.selectedProduct === 'all') {
        this.statsData = this.statsData_tmp
        return
      }

      // Si "Santé" est sélectionné, on ne garde que les lignes avec type_produit = null / undefined
      if (this.selectedProduct === 'sante') {
        this.statsData = (this.statsData_tmp || []).filter(item => item && item.type_produit == null)
        return
      }

      // Cas générique: tout produit différent de "all" et "sante"
      this.statsData = (this.statsData_tmp || []).filter( item => item && item.type_produit === this.selectedProduct)
    },
    formatThounsends(value, fixe = false, number = 0) {
      if (value === null || value === undefined) return '0'
      value = parseFloat(value)
      if (fixe) {
        value = value.toFixed(number)
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    getSortedDetails(details) {
      if (!details || details.length === 0) return []
      return [...details].sort((a, b) => {
        const leadsA = a.nbr_leads || 0
        const leadsB = b.nbr_leads || 0
        return leadsB - leadsA // Tri décroissant
      })
    },
    getTotalCA(tagPrincipal) {
      if (!tagPrincipal.details || tagPrincipal.details.length === 0) {
        return 0
      }
      return tagPrincipal.details.reduce((total, detail) => {
        const nomSousTag = (detail.nom_sous_tag || '').toUpperCase()

        // Pour les sous-tags MON GUSTAVE, on utilise CA MG + CA WM
        if (
            (nomSousTag.includes('MON GUSTAVE') && !nomSousTag.includes('MON GUSTAVE CREDIT CONSO PB'))
            || nomSousTag.includes('_CREDIT CONSO.')
        ) {
          const caMg = parseFloat(detail.ca_mg) || 0
          const caWm = parseFloat(detail.ca_wm) || 0
          return total + caMg + caWm
        }

        // Comportement existant pour le reste
        return total + (parseFloat(detail.ca) || 0)
      }, 0)
    },
    sortByTotalCA(a, b) {
      const caA = this.getTotalCA(a)
      const caB = this.getTotalCA(b)
      return caA - caB
    },
    color_marge(row) {
      const ca_mg = row.ca_mg || 0
      const ca_wm = row.ca_wm || 0
      const cae = row.cae || 0
      const marge = cae != 0 ? (((ca_mg + ca_wm) - cae) * 100) / cae : 0
      if (marge >= 30) {
        return 'color: green'
      }
      else if (marge >= 20) {
        return 'color: rgb(252, 255, 62)'
      }
      else if (marge >= 0) {
        return 'color: orange'
      }
      else {
        return 'color: red'
      }
    },
    color_marge_summary() {
      const marge = this.totalMarge
      if (marge >= 0) {
        return 'text-success'
      }
      else {
        return 'text-danger'
      }
    },
    getSpendGroupedSummaries(param) {
      const { columns } = param;
      const data = this.spend_grouped || [];
      let totalSpend = 0;
      let totalCA = 0;
      let totalMarge = 0;
      data.forEach(row => {
        totalSpend += parseFloat(row.spend) || 0;
        totalCA += parseFloat(row.ca_an) || 0;
        totalMarge += parseFloat(row.marge) || 0;
      });
      const pourcentageMarge = totalCA !== 0 ? (totalMarge / totalCA) * 100 : 0;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '';
          return;
        }
        if (index === 1) {
          sums[index] = this.formatThounsends(totalSpend, true, 2) + ' €';
          return;
        }
        if (index === 2) {
          sums[index] = this.formatThounsends(totalCA, true, 0) + ' €';
          return;
        }
        if (index === 3) {
          sums[index] = this.formatThounsends(totalMarge, true, 2) + ' €';
          return;
        }
        if (index === 4) {
          sums[index] = this.formatThounsends(pourcentageMarge, true, 2) + ' %';
          return;
        }
        sums[index] = '';
      });
      return sums;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      // 1) Si Apollo n’a pas encore fini (SkipQuery_caByTag == false), on ne calcule pas
      if (!this.SkipQuery_caByTag) {
        columns.forEach((column, index) => {
          sums[index] = '';
        });
        return sums;
      }

      // 2) Quand SkipQuery_caByTag == true (Apollo terminé), on calcule normalement
      let totalNbrCliques = 0;
      let totalNbrCliquesSum = 0;
      let totalNbrLeadsSum = 0;
      let totalCA = 0;

      // Calculer les totaux à partir de toutes les données filtrées (pas seulement la page actuelle)
      this.filteredStatsData.forEach(item => {
        totalNbrCliques += item.nbr_cliques || 0;
        totalNbrCliquesSum += item.nbr_cliques_sum || 0;
        totalNbrLeadsSum += item.nbr_leads_sum || 0;
        totalCA += this.getTotalCA(item);
      });

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '';
          return;
        } else if (index === 1) {
          sums[index] = '';
          return;
        } else if (index === 2) {
          sums[index] = this.formatThounsends(totalNbrCliques);
          return;
        } else if (index === 3) {
          sums[index] = this.formatThounsends(totalNbrCliquesSum);
          return;
        } else if (index === 4) {
          sums[index] = this.formatThounsends(totalNbrLeadsSum);
          return;
        } else if (index === 5) {
          sums[index] = this.formatThounsends(totalCA, true, 1) + ' €';
          return;
        } else {
          sums[index] = '';
          return;
        }
      });
      return sums;
    }
  },
  watch: {
    'pagination.perPage'() {
      this.pagination.currentPage = 1;
    },
    searchQuery() {
      this.pagination.currentPage = 1;
    },
    selectedProduct() {
      // Réinitialiser la pagination et appliquer le filtre produit quand la sélection change
      this.pagination.currentPage = 1;
      this.applyProductFilter();
    }
  },
  mounted() {
    this.fetchStats()
  }
}
</script>

<style scoped>
/* .el-table__expand-column .cell {
  padding-right: 10px !important;
} */
/* ::v-deep .el-table__expanded-cell {
  padding-right: 5px !important;
} */
.expanded-content {
  background: rgba(0, 0, 0, 0.15);
}

.details-table {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.details-table::before {
  display: none;
}

.main-tag-name {
  font-size: 13.5px !important;
}

.detail-tag-name {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.detail-number {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  font-size: 12px;
}

.summary-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 0px !important;
}

.summary-card .card-body {
  padding: 1.5rem;
}

.summary-card .card-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

.summary-card .card-subtitle {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Sur petits écrans, force une largeur minimale pour activer le scroll */
/* @media (max-width: 1200px) {
  .expanded-content {
    min-width: 490px;
  }
} */

</style>

